/**
 * 全局错误处理和警告过滤
 *
 * 这个文件用于：
 * 1. 屏蔽浏览器扩展产生的非致命警告（如 runtime.lastError）
 * 2. 过滤 Element Plus 等组件库的已知警告（如 ResizeObserver）
 * 3. 捕获并处理全局错误
 */

if (typeof window !== 'undefined') {
  // 需要过滤的非致命警告/错误关键词
  const filteredPatterns = [
    'runtime.lastError',
    'ResizeObserver loop',
    'ResizeObserver Loop',
    'ResizeObserver loop completed with undelivered notifications',
    'ElementPlusError',
    'label act as value is about to be deprecated',
    'Unchecked runtime.lastError',
    'message channel closed',
  ]

  // 检查是否需要过滤
  const shouldFilter = (message) => {
    if (!message) return false
    const msg = typeof message === 'string' ? message : message.toString()
    return filteredPatterns.some((pattern) => msg.includes(pattern))
  }

  // 保存原始方法
  const originalError = console.error
  const originalWarn = console.warn

  // 重写 console.error
  console.error = (...args) => {
    // 过滤已知非致命错误
    if (args[0] && shouldFilter(args[0])) {
      // 静默忽略，不输出到控制台
      return
    }
    originalError.apply(console, args)
  }

  // 重写 console.warn
  console.warn = (...args) => {
    // 过滤已知警告
    if (args[0] && shouldFilter(args[0])) {
      // 静默忽略，不输出到控制台
      return
    }
    originalWarn.apply(console, args)
  }

  // 全局错误处理 - 过滤非致命错误
  const originalOnError = window.onerror
  window.onerror = function (msg, url, line, col, error) {
    // 如果是 ResizeObserver 相关错误，静默忽略
    if (shouldFilter(msg)) {
      return true // 返回 true 表示已处理，不再向上传播
    }
    // 调用原始处理程序
    if (originalOnError) {
      return originalOnError.apply(this, arguments)
    }
    return false
  }

  // 未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', function (event) {
    // 如果是已知的非致命错误，阻止默认处理
    if (event.reason && shouldFilter(event.reason.message || event.reason)) {
      event.preventDefault()
      event.stopPropagation()
    }
  })
}
